import { render, staticRenderFns } from "./ArtworkEditor.vue?vue&type=template&id=31d5903c&scoped=true"
import script from "./ArtworkEditor.vue?vue&type=script&lang=js"
export * from "./ArtworkEditor.vue?vue&type=script&lang=js"
import style0 from "./ArtworkEditor.vue?vue&type=style&index=0&id=31d5903c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5903c",
  null
  
)

export default component.exports